export default "__VITE_ASSET__1f9486c8__"